module.exports = __webpack_public_path__ + "img/plan3_book10.a940b191.png";